export const NAME = 'logout';

// Actions Types pour délogger le user
export const REQUEST_LOGOUT = 'REQUEST_LOGOUT';
export const SUCCESS_LOGOUT = 'SUCCESS_LOGOUT';
export const FAILURE_LOGOUT = 'FAILURE_LOGOUT';



// WEBPACK FOOTER //
// ./src/services/authentication/logout/constants.js